module.exports = __webpack_public_path__ + "static/media/instagram_icon.896848fd.svg";